import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../../hooks/useTypedReactRedux.ts';
import { activeSignInProfileSelector } from '../../sign-in-profiles/selectors.ts';
import { DEFAULT_HELP_PROMPT_DELAY_SECONDS } from '../../sign-in-profiles/types.ts';

export const useHelpPromptTimer = () => {
    const [visible, setVisible] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const activeProfile = useAppSelector(activeSignInProfileSelector);

    const delaySeconds = activeProfile?.helpPromptDelaySeconds ?? DEFAULT_HELP_PROMPT_DELAY_SECONDS;

    useEffect(() => {
        console.debug('LOGIN APP. HELP PROMPT TIMER. STARTING', { delaySeconds });

        timerRef.current = setTimeout(() => {
            console.debug('LOGIN APP. HELP PROMPT TIMER. ELAPSED');
            setVisible(true);
        }, delaySeconds * 1000);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [delaySeconds]);

    const dismiss = () => {
        setVisible(false);
    };

    return { visible, dismiss };
};
